import { createSlice } from '@reduxjs/toolkit';
import { fetchEmailTemplates, updateEmailTemplate } from '../thunks/emailTemplatesThunks.js';

const initialState = {
    loading: false,
    templates: [],
    error: null,
};

const emailTemplatesSlice = createSlice({
    name: 'emailTemplates',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addMatcher(
                (action) => [fetchEmailTemplates.pending.type, updateEmailTemplate.pending.type].includes(action.type),
                (state) => {
                    state.loading = true;
                    state.error = null;
                },
            )
            .addMatcher(
                (action) =>
                    [fetchEmailTemplates.rejected.type, updateEmailTemplate.rejected.type].includes(action.type),
                (state, action) => {
                    state.loading = false;
                    state.error = action.payload || action.error?.message;
                },
            )
            .addMatcher(
                (action) =>
                    [fetchEmailTemplates.fulfilled.type, updateEmailTemplate.fulfilled.type].includes(action.type),
                (state, action) => {
                    state.loading = false;
                    state.templates = action.payload;
                    state.error = null;
                },
            )
            .addDefaultCase((state) => state);
    },
});

export default emailTemplatesSlice.reducer;
